import React, { useState } from "react";
import "../Styles/BusBookingReviewPage.css";
import Navber from "./Navber.jsx"

const BookingReviewPage = () => {
    const [traveller, setTraveller] = useState({
        title: "MR.",
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
    });

    return (
        <>
            <div style={{ backgroundColor: "#f0f0f0" }}>
                <Navber />
            </div>
            <div className="reviewbooking-container">
                {/* Heading */}
                <h2 className="reviewbooking-heading">Review your Booking</h2>

                <div className="reviewbooking-main">
                    {/* Bus Details */}
                    <div className="reviewbooking-buscard">
                        <h3 className="reviewbooking-bus-title">Intercity Smart Bus</h3>
                        <p className="reviewbooking-bus-sub">A/C seater / Sleeper</p>

                        <div className="reviewbooking-journey">
                            <div>
                                <span style={{ fontSize: "1rem", fontWeight: '600' }}>23:50 2 Sep'25 , TUE</span>
                                <p>Delhi</p>
                                <p className="reviewbooking-location">
                                    Zero point, greater noida <br />
                                    Above Starting/Merger on Yamuna Expressway (Delhi)
                                </p>
                            </div>

                            <div className="reviewbooking-duration">
                                <span>6h 55min</span>
                            </div>

                            <div>
                                <span style={{ fontSize: "1rem", fontWeight: '600' }}>06:45 3 Sep'25 , TUE</span>
                                <p>Kanpur (Uttar Pradesh)</p>
                                <p className="reviewbooking-location">
                                    Fazalganj chauraha - intrcity lounge <br />
                                    IntrCity Lounge, Kalpi Road, Near Legend Hotel (Kanpur)
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* Price Details */}
                    <div className="reviewbooking-pricecard">
                        <h3>Price Details</h3>
                        <div className="reviewbooking-pricerow">
                            <span>Base Fare</span>
                            <span>359.0/-</span>
                        </div>
                        <hr />
                        <div className="reviewbooking-pricerow reviewbooking-total">
                            <span>Amount</span>
                            <span>359.0/-</span>
                        </div>
                        <button className="reviewbooking-bookbtn">Book Now</button>
                    </div>
                </div>

                {/* Traveller Details */}
                <div className="reviewbooking-travellercard">
                    <h3>Traveller’s Details</h3>

                    <label className="reviewbooking-checkbox">
                        <input type="checkbox" /> Same as Profile Information
                    </label>

                    <div className="reviewbooking-form">
                        <select
                            value={traveller.title}
                            onChange={(e) =>
                                setTraveller({ ...traveller, title: e.target.value })
                            }
                        >
                            <option>MR.</option>
                            <option>MRS.</option>
                            <option>MS.</option>
                        </select>

                        <input type="text" placeholder="First Name" />
                        <input type="text" placeholder="Last Name" />
                        <input type="email" placeholder="Enter email address" />
                        <input type="tel" placeholder="Enter Phone number" />
                    </div>

                    <button className="reviewbooking-addguest">+ Add Guest</button>
                </div>

                {/* Agreement */}
                <div className="reviewbooking-agreement">
                    <label>
                        <input type="checkbox" /> By proceeding, I agree to MakeMyTrip’s{" "}
                        <a href="#">User Agreement</a>,{" "}
                        <a href="#">Terms of Service</a> and{" "}
                        <a href="#">Cancellation & Property Booking Policies</a>.
                    </label>
                </div>
            </div>
        </>

    );
};

export default BookingReviewPage;
